module.exports = __webpack_public_path__ + "img/habitacion.30c96a46.svg";